import { adminConsoleLogin, adminConsoleMessages, AdminConsoleState, useAppSelector } from 'azshared';
import React, { Fragment, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { Outlet } from 'react-router-dom';
import { AppButton } from '../../components/buttons/app-button';
import { Menu } from '../../components/menu/menu';
import { useAppDispatch } from '../../hooks/redux';
import './admin-console-container.scss';
import { Header } from './menu-header/menu-header';

export const AdminConsoleContainer = () => {
  const { user, loginStatus, loginError }: AdminConsoleState = useAppSelector((state) => state.features.adminConsole.common);
  const dispatch = useAppDispatch();
  const { formatMessage } = useIntl();
  const [countLogin, setCountLogin] = useState(0);

  useEffect(() => {
    if (!user && countLogin === 0) {
      dispatch(adminConsoleLogin());
      setCountLogin(p => p+1);
    }
  }, [user, dispatch, countLogin]);


  return (
    <Fragment>
   {user && <div className='admin-console-container'>
      <Menu>
        <Header userName={`${user?.name} ${user?.surname}`} />
      </Menu>

      <div className='content'>
        <Outlet />
      </div>
    </div>}
   {!user && loginStatus === 'failed' && <div className='admin-console-login-error'>
      <p>{formatMessage(loginError === 'NOT_AUTHORIZED' ? adminConsoleMessages.loginNotAuthorized : adminConsoleMessages.loginFailed)}</p>
      <AppButton label={formatMessage(adminConsoleMessages.loginRetry)} onClick={() => dispatch(adminConsoleLogin())} />
    </div>}
    </Fragment>
  );
};
